import fetch from "../utils/fetch";

export const getAllCenters = () => {
  return fetch.get("/unidadenegocio");
};
